import React from "react";

const Contactmap = () => {
  return (
    <>
      <div class="map-con">
        <iframe
          title="Google Map of Derby Confectionery"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15074.505600376482!2d73.1883828!3d19.1678242!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be793928112ee19%3A0xf9db329bcbcfbf3!2sDerby%20Confectionery%20-%20Suncrest%20Food%20Makers!5e0!3m2!1sen!2sin!4v1710769541117!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </>
  );
};

export default Contactmap;
